module.exports = __webpack_public_path__ + "static/agence-web-référencement-naturel-1271c01a05a3bbd02056825301e32980.png";